<template>
    <div v-if="!loadingPage">
        <div v-if="isAdminIdentityVerified" class="pb-2">
            <div class="d-flex justify-content-between align-items-center">
                <div class="mb-2 d-flex align-items-center">
                    <h3 class="text-primary mb-0">کمپین‌های هوشمند</h3>
                    <feather-icon @click="$bvModal.show('campaign-description')" size="21" icon="HelpCircleIcon"
                        class="text-muted ml-75 pointer" />
                </div>
                <div class="mb-2">
                    <b-button type="submit" variant="primary" :disabled="loadingCustomers" @click="customerChoice"
                        class="w-100 d-flex align-items-center justify-content-center px-3">
                        <b-spinner v-if="loadingCustomers" class="mr-50" variant="white" small></b-spinner>
                        <span>ایجاد</span>
                    </b-button>
                </div>
            </div>
            <b-row>
                <b-col lg="3" md="6" class="mt-25">
                    <b-form-group label="تاریخ شروع ایجاد کمپین" label-for="fromId">
                        <b-form-input id="fromId" class="text-center main-input font-weight-bolder pointer"
                            :value="parameters.from ? formatDate(parameters.from) : null" autocomplete="off"
                            name="fromId" />
                        <date-picker v-model="parameters.from" format="YYYY-MM-DD" display-format="jYYYY-jMM-jDD"
                            custom-input="#fromId" />
                    </b-form-group>
                </b-col>
                <b-col lg="3" md="6" class="mt-25">
                    <b-form-group label="تاریخ پایان ایجاد کمپین" label-for="toId">
                        <b-form-input id="toId" class="text-center main-input font-weight-bolder pointer" name="toId"
                            :value="parameters.to ? formatDate(parameters.to) : null" autocomplete="off" />
                        <date-picker v-model="parameters.to" format="YYYY-MM-DD" display-format="jYYYY-jMM-jDD"
                            custom-input="#toId" />
                    </b-form-group>
                </b-col>
                <b-col lg="2" md="4" class="mt-25">
                    <b-form-group label="وضعیت" label-for="typeId">
                        <v-select v-model="parameters.isActive" :searchable="false" dir="rtl"
                            :options="isActiveManagement" class="bg-white" id="isActivedId" autocomplete="off"
                            :reduce="(value) => value.id" style="border-radius: 6px;" label="name" :clearable="false">
                            <template #no-options>
                                موردی وجود ندارد
                            </template>
                        </v-select>
                    </b-form-group>
                </b-col>
                <b-col lg="2" md="4" class="mt-md-2 mt-50">
                    <b-button @click="removeFilters" variant="secondary"
                        class="mt-md-25 mt-0 d-flex justify-content-center w-100" :disabled="loading">
                        <span>حذف فیلتر ها</span>
                        <b-spinner v-if="loading" variant="white" class="ml-50" small></b-spinner>
                    </b-button>
                </b-col>
                <b-col lg="2" md="4" class="mt-md-2 mt-1">
                    <b-button variant="info" @click="getCampaigns" :disabled="loading"
                        class="mt-md-25 mt-0 d-flex justify-content-center w-100">
                        <span>اعمال فیلتر</span>
                        <b-spinner v-if="loading" variant="white" class="ml-50" small></b-spinner>
                    </b-button>
                </b-col>
            </b-row>
            <div class="mt-2 mt-md-1">
                <b-card class="p-0" no-body>
                    <b-overlay v-if="campaigns.length" :show="loading" variant="transparent" opacity="1" blur="3px"
                        rounded="sm">
                        <b-table responsive :items="campaigns" :fields="fields" class="mb-0" striped>
                            <template #cell(edit)="data">
                                <b-spinner v-if="loadingbuttons[data.index]" variant="info" small></b-spinner>
                                <feather-icon v-else @click="showModalEdit(data.item, data.index)" size="18"
                                    icon="EditIcon" class="pointer text-info" color="#8d88a3" />
                            </template>
                            <template #cell(type)="data">
                                <div v-if="data.item.type == 0">تولد</div>
                                <div v-if="data.item.type == 1">مشتریان</div>
                                <div v-if="data.item.type == 2">عمومی</div>
                            </template>
                            <template #cell(isActive)="data">
                                <div v-if="data.item.isActive" class="text-success">فعال</div>
                                <div v-else class="text-warning">غیرفعال</div>
                            </template>
                            <template #cell(totalOrdersAmount)="data">
                                {{ data.item.totalOrdersAmount.toLocaleString('fa-IR') }}
                            </template>
                            <template #cell(totalDiscountGiven)="data">
                                {{ data.item.totalDiscountGiven.toLocaleString('fa-IR') }}
                            </template>
                            <template #cell(endDate)="data">
                                <span>
                                    {{ new Date(data.item.endDate).toLocaleDateString('fa-IR') }}
                                </span>
                                <span> - </span>
                                <span>
                                    {{ new
                                        Date(data.item.endDate).toLocaleTimeString('fa-IR').split(":").slice(0,
                                            2).join(":") }}
                                </span>
                            </template>
                            <template #cell(startDate)="data">
                                <span>
                                    {{ new Date(data.item.startDate).toLocaleDateString('fa-IR') }}
                                </span>
                                <span> - </span>
                                <span>
                                    {{ new
                                        Date(data.item.startDate).toLocaleTimeString('fa-IR').split(":").slice(0,
                                            2).join(":") }}
                                </span>
                            </template>
                            <template #cell(createdAt)="data">
                                <span>
                                    {{ new Date(data.item.createdAt).toLocaleDateString('fa-IR') }}
                                </span>
                                <span> - </span>
                                <span>
                                    {{ new
                                        Date(data.item.createdAt).toLocaleTimeString('fa-IR').split(":").slice(0,
                                            2).join(":") }}
                                </span>
                            </template>
                        </b-table>
                    </b-overlay>
                    <div v-else class="text-center py-4">
                        موردی وجود ندارد
                    </div>
                </b-card>
                <b-pagination align="center" @input="getCampaigns" v-model="parameters.pageIndex"
                    :total-rows="parameters.totalCount" :per-page="parameters.pageSize" />
            </div>


            <!------------------------------- modal campaign description ------------------------------->
            <b-modal id="campaign-description" title="کمپین‌های هوشمند" centered :hide-footer="true"
                title-class="font-weight-bolder" size="md">
                <div class="p-75">
                    <p v-for="(item, index) in campaignDescription" :key="index">
                        {{ item }}
                    </p>
                </div>
            </b-modal>

            <!------------------------------- modal edit and create campaign ------------------------------->
            <b-modal id="create-campaign" :title="`${modeCampaign} کمپین‌`" centered :hide-footer="true"
                title-class="font-weight-bolder" size="lg">

                <validation-observer ref="createCampaign">
                    <b-form @submit.prevent class="px-1 pt-50">
                        <b-row>
                            <b-col lg="6" md="12" class="mt-25">
                                <b-form-group label="نوع کمپین" label-for="typeId" class="text-center">
                                    <validation-provider name="نوع کمپین" #default="{ errors }" rules="required">
                                        <v-select v-model="form.type" :searchable="false" dir="rtl"
                                            :disabled="modeCampaign == 'ویرایش'" :reduce="(value) => value.id"
                                            class="bg-white" :class="errors.length > 0 ? 'border-danger' : null"
                                            style="border-radius: 6px;" label="name" :clearable="false"
                                            :options="listTypes">
                                            <template #no-options>
                                                موردی وجود ندارد
                                            </template>
                                        </v-select>
                                        <small class="text-danger">{{ errors[0] }}</small>
                                    </validation-provider>
                                </b-form-group>
                            </b-col>
                            <b-col v-if="form.type == 1" lg="6" md="12" class="mt-25">
                                <div @click="managementCustomerSelection(1)" class="pointer mb-1">
                                    <div class="text-center">انتخاب مشتریان</div>
                                    <div class="border rounded mt-25 p-50 text-center">
                                        {{ selectedCount }} مشتری
                                    </div>
                                </div>
                            </b-col>
                        </b-row>
                        <b-row>
                            <b-col lg="6" md="12" class="mt-25">
                                <b-form-group label="عنوان کمپین" label-for="titleId" class="text-center">
                                    <validation-provider name="عنوان کمپین" #default="{ errors }" rules="required">
                                        <b-form-input :class="errors.length > 0 ? 'border-danger' : null"
                                            v-model="form.title" id="titleId" autocomplete="off" class="text-center"
                                            name="titleId" />
                                        <small class="text-danger">{{ errors[0] }}</small>
                                    </validation-provider>
                                </b-form-group>
                            </b-col>
                            <b-col lg="6" md="12" class="mt-25">
                                <b-form-group label="درصد تخفیف" label-for="discountPercentId" class="text-center">
                                    <validation-provider name="درصد تخفیف" #default="{ errors }" rules="required">
                                        <b-form-input type="number" :class="errors.length > 0 ? 'border-danger' : null"
                                            v-model="form.discountPercent" id="discountPercentId" autocomplete="off"
                                            class="text-center" name="discountPercentId" />
                                        <small class="text-danger">{{ errors[0] }}</small>
                                    </validation-provider>
                                </b-form-group>
                            </b-col>
                            <b-col lg="6" md="12" class="mt-25">
                                <b-form-group label="اولویت کمپین" label-for="priorityId" class="text-center">
                                    <validation-provider name="اولویت کمپین" #default="{ errors }" rules="required">
                                        <b-form-input type="number" :class="errors.length > 0 ? 'border-danger' : null"
                                            v-model="form.priority" id="priorityId" autocomplete="off"
                                            class="text-center" name="priorityId" />
                                        <small class="text-danger">{{ errors[0] }}</small>
                                    </validation-provider>
                                </b-form-group>
                            </b-col>
                            <b-col lg="6" md="12" class="mt-25">
                                <b-form-group label="حداکثر تعداد فاکتور در کمپین" label-for="maxOrdersCountId"
                                    class="text-center">
                                    <b-form-input type="number" v-model="form.maxOrdersCount" id="maxOrdersCountId"
                                        autocomplete="off" class="text-center" name="maxOrdersCountId" />
                                </b-form-group>
                            </b-col>
                            <b-col lg="6" md="12" class="mt-25">
                                <b-form-group label="زمان شروع کمپین" label-for="startDateId" class="text-center">
                                    <validation-provider #default="{ errors }" name="زمان شروع" rules="required">
                                        <b-form-input id="startDateId" class="text-center main-input pointer"
                                            :class="errors.length > 0 ? 'border-danger' : null"
                                            :value="getDisplayDateTime(form.startDate)" autocomplete="off"
                                            name="startDateId" />
                                        <date-picker v-model="form.startDate" :min="currentDate" type="datetime"
                                            format="YYYY-MM-DDTHH:mm:ss.SSSZ" display-format="jYYYY/jMM/jDD - HH:mm"
                                            custom-input="#startDateId" />
                                        <small class="text-danger">{{ errors[0] }}</small>
                                    </validation-provider>
                                </b-form-group>
                            </b-col>
                            <b-col lg="6" md="12" class="mt-25">
                                <b-form-group label="زمان پایان کمپین" label-for="endDateId" class="text-center">
                                    <validation-provider #default="{ errors }" name="زمان پایان" rules="required">
                                        <b-form-input id="endDateId" class="text-center main-input pointer"
                                            :class="errors.length > 0 ? 'border-danger' : null"
                                            :value="getDisplayDateTime(form.endDate)" autocomplete="off"
                                            name="endDateId" />
                                        <date-picker v-model="form.endDate" :min="currentDate" type="datetime"
                                            format="YYYY-MM-DDTHH:mm:ss.SSSZ" display-format="jYYYY/jMM/jDD - HH:mm"
                                            custom-input="#endDateId" />
                                        <small class="text-danger">{{ errors[0] }}</small>
                                    </validation-provider>
                                </b-form-group>
                            </b-col>
                            <!-- <b-col lg="6" md="12" class="mt-25">
                                <div @click="managementProductSelection(1)" class="pointer mb-1">
                                    <div class="text-center">انتخاب محصولات</div>
                                    <div class="border rounded mt-25 p-50 text-center">
                                        {{ form.productIds.length }} محصول
                                    </div>
                                </div>
                            </b-col> -->
                            <b-col lg="6" md="12" class="mt-25">
                                <b-form-group label-for="minimumPurchaseAmount"
                                    label="حداقل مبلغ خرید در هر فاکتور (ریال)" class="text-center">
                                    <cleave id="minimumPurchaseAmount" dir="ltr" v-model="form.minimumPurchaseAmount"
                                        class="form-control mt-50 text-center" autocomplete="off"
                                        :options="options.number" inputmode="numeric" />
                                </b-form-group>
                            </b-col>
                            <b-col lg="6" md="12" class="mt-25">
                                <b-form-group label-for="maxTotalDiscountAmount"
                                    label="حداکثر مجموعه تخفیف در کمپین (ریال)" class="text-center">
                                    <cleave id="maxTotalDiscountAmount" dir="ltr" v-model="form.maxTotalDiscountAmount"
                                        class="form-control mt-50 text-center" autocomplete="off"
                                        :options="options.number" inputmode="numeric" />
                                </b-form-group>
                            </b-col>
                            <b-col lg="12" md="12" class="mt-25">
                                <b-form-group label="توضیحات کمپین" label-for="descriptionId" class="text-center">
                                    <b-form-input v-model="form.description" id="descriptionId" autocomplete="off"
                                        class="text-center" name="descriptionId" />
                                </b-form-group>
                            </b-col>
                            <b-col v-if="modeCampaign == 'ویرایش'" lg="6" md="12">
                                <b-button :variant="campaignStatus ? 'warning' : 'success'"
                                    @click="campaignChangeStatus" :disabled="loadingButton" class="w-100 mt-1 mb-75">
                                    {{ campaignStatus ? 'غیرفعال‌سازی کمپین' : 'فعال‌سازی کمپین' }}
                                </b-button>
                            </b-col>
                            <b-col :lg="modeCampaign == 'ویرایش' ? '6' : '12'" md="12">
                                <b-button variant="primary" @click="createOrEdit" :disabled="loadingButton"
                                    class="mt-25 mt-md-1 mb-75 d-flex justify-content-center w-100">
                                    <b-spinner v-if="loadingButton" variant="white" class="mr-50" small></b-spinner>
                                    <span>{{ modeCampaign }} کمپین‌ </span>
                                </b-button>
                            </b-col>
                        </b-row>
                    </b-form>
                </validation-observer>
            </b-modal>


            <!------------------------------- modal product choice ------------------------------->
            <b-modal id="product-choice" title="انتخاب محصولات" centered :hide-footer="true"
                title-class="font-weight-bolder" size="lg">
                <b-card class="p-0" no-body>
                    <b-table responsive :items="getTableItems()" :fields="fieldsProduct" class="mb-0" striped>
                        <template #cell(productInfo)="data">
                            <div v-if="data.item.isCategory" class="d-flex align-items-center">
                                <b-form-checkbox :checked="isCategoryFullySelected(data.item.categoryId)"
                                    :indeterminate="isCategoryPartiallySelected(data.item.categoryId)"
                                    @change="toggleCategorySelection(data.item.categoryId)" />
                                <h4 class="font-weight-bolder mb-0">
                                    {{ data.item.productName }}
                                </h4>
                            </div>

                            <div v-else class="d-flex align-items-center">
                                <b-form-checkbox :checked="form.productIds.includes(data.item.id)"
                                    @change="toggleProductSelection(data.item.id)" />
                                <h5 class="mb-0">
                                    {{ data.item.productName }}
                                </h5>
                            </div>
                        </template>
                        <template #cell(price)="data">
                            <span v-if="!data.item.isCategory">
                                {{ data.item.basePrice.toLocaleString('fa-IR') }} ریال
                            </span>
                        </template>
                    </b-table>
                </b-card>
                <b-button variant="info" @click="managementProductSelection(2)" class="w-100  mb-50">
                    تایید
                </b-button>
            </b-modal>


            <!------------------------------- modal customers choice ------------------------------->
            <b-modal id="customer-choice" title="انتخاب مشتریان" centered :hide-footer="true"
                title-class="font-weight-bolder" size="lg">
                <b-row>
                    <b-col lg="4" md="6" class="mt-25">
                        <b-form-group label="نام - نام خانوادگی - شماره اشتراک" label-for="searchTermId">
                            <b-form-input @keyup.enter="getCustomers" v-model="parametersCustomers.searchTerm"
                                id="searchTermId" autocomplete="off" class="text-center" name="searchTermId" />
                        </b-form-group>
                    </b-col>
                    <b-col lg="4" md="6" class="mt-25">
                        <b-form-group label="شماره همراه" label-for="phoneNumberId">
                            <b-form-input dir="ltr" type="number" @keyup.enter="getCustomers"
                                v-model="parametersCustomers.phoneNumber" id="phoneNumberId" autocomplete="off"
                                class="text-center" name="phoneNumberId" />
                        </b-form-group>
                    </b-col>
                    <b-col lg="4" md="6" class="mt-25">
                        <b-form-group label="شماره سطح" label-for="levelNumberId">
                            <b-form-input dir="ltr" type="number" v-model="parametersCustomers.levelNumber"
                                id="levelNumberId" @keyup.enter="getCustomers" autocomplete="off" class="text-center"
                                name="levelNumberId" />
                        </b-form-group>
                    </b-col>
                    <b-col lg="4" md="6" class="mt-25">
                        <b-form-group label="از امتیاز" label-for="startScoreId">
                            <b-form-input dir="ltr" type="number" v-model="parametersCustomers.minScore"
                                id="startScoreId" @keyup.enter="getCustomers" autocomplete="off" class="text-center"
                                name="startScoreId" />
                        </b-form-group>
                    </b-col>
                    <b-col lg="4" md="6" class="mt-25">
                        <b-form-group label="تا امتیاز" label-for="endScoreId">
                            <b-form-input dir="ltr" type="number" v-model="parametersCustomers.maxScore" id="endScoreId"
                                @keyup.enter="getCustomers" autocomplete="off" class="text-center" name="endScoreId" />
                        </b-form-group>
                    </b-col>
                    <b-col lg="4" md="6" class="mt-25">
                        <b-form-group label="از تعداد خرید" label-for="minTotalOrdersCountId">
                            <b-form-input dir="ltr" type="number" v-model="parametersCustomers.minTotalOrdersCount"
                                @keyup.enter="getCustomers" id="minTotalOrdersCountId" autocomplete="off"
                                class="text-center" name="minTotalOrdersCountId" />
                        </b-form-group>
                    </b-col>
                    <b-col lg="4" md="6" class="mt-25">
                        <b-form-group label="تا تعداد خرید" label-for="maxTotalOrdersCountId">
                            <b-form-input dir="ltr" type="number" v-model="parametersCustomers.maxTotalOrdersCount"
                                @keyup.enter="getCustomers" id="maxTotalOrdersCountId" autocomplete="off"
                                class="text-center" name="maxTotalOrdersCountId" />
                        </b-form-group>
                    </b-col>
                    <b-col lg="4" md="6" class="mt-25">
                        <b-form-group label="از آخرین خرید (روز)" label-for="minDaysNumberSinceLastOrderedId">
                            <b-form-input dir="ltr" type="number"
                                v-model="parametersCustomers.minDaysNumberSinceLastOrdered" @keyup.enter="getCustomers"
                                id="minDaysNumberSinceLastOrderedId" autocomplete="off" class="text-center"
                                name="minDaysNumberSinceLastOrderedId" />
                        </b-form-group>
                    </b-col>
                    <b-col lg="4" md="6" class="mt-25">
                        <b-form-group label="تا آخرین خرید (روز)" label-for="maxDaysNumberSinceLastOrderedId">
                            <b-form-input dir="ltr" type="number"
                                v-model="parametersCustomers.maxDaysNumberSinceLastOrdered" @keyup.enter="getCustomers"
                                id="maxDaysNumberSinceLastOrderedId" autocomplete="off" class="text-center"
                                name="maxDaysNumberSinceLastOrderedId" />
                        </b-form-group>
                    </b-col>
                    <b-col lg="4" md="6" class="mt-25">
                        <b-form-group label="از مبلغ خرید" label-for="minTotalOrdersAmountId">
                            <b-form-input dir="ltr" type="number" v-model="parametersCustomers.minTotalOrdersAmount"
                                @keyup.enter="getCustomers" id="minTotalOrdersAmountId" autocomplete="off"
                                class="text-center" name="minTotalOrdersAmountId" />
                        </b-form-group>
                    </b-col>
                    <b-col lg="4" md="6" class="mt-25">
                        <b-form-group label="تا مبلغ خرید" label-for="maxTotalOrdersAmountId">
                            <b-form-input dir="ltr" type="number" v-model="parametersCustomers.maxTotalOrdersAmount"
                                @keyup.enter="getCustomers" id="maxTotalOrdersAmountId" autocomplete="off"
                                class="text-center" name="maxTotalOrdersAmountId" />
                        </b-form-group>
                    </b-col>
                    <b-col lg="4" md="6" class="mt-25">
                        <b-form-group label="وفاداری" label-for="groupId">
                            <v-select v-model="parametersCustomers.groupId" :searchable="false" dir="rtl"
                                :options="groupIdData" :reduce="(value) => value.id" label="name" id="groupId"
                                class="bg-white" style="border-radius: 6px;" :clearable="false">
                                <template #no-options>
                                    موردی وجود ندارد
                                </template>
                            </v-select>
                        </b-form-group>
                    </b-col>
                    <b-col lg="4" md="6" class="mt-25">
                        <b-form-group label="محصول مورد علاقه" label-for="favoriteProductId">
                            <v-select v-model="parametersCustomers.favoriteProductId" dir="rtl" :options="products"
                                :reduce="(value) => value.id" label="name_Fa" id="favoriteProductId" class="bg-white"
                                style="border-radius: 6px;" :clearable="false">
                                <template #no-options>
                                    موردی وجود ندارد
                                </template>
                            </v-select>
                        </b-form-group>
                    </b-col>
                    <b-col lg="4" md="6" class="mt-25">
                        <b-form-group label="نوع ترتیب نمایش" label-for="sortById">
                            <v-select v-model="parametersCustomers.sortBy" :searchable="false" dir="rtl"
                                :options="sortByData" :reduce="(value) => value.id" label="name" id="sortById"
                                class="bg-white" style="border-radius: 6px;" :clearable="false">
                                <template #no-options>
                                    موردی وجود ندارد
                                </template>
                            </v-select>
                        </b-form-group>
                    </b-col>
                    <b-col lg="4" md="4" class="mt-25">
                        <b-form-group label="ترتیب نمایش" label-for="sortDescendingId">
                            <v-select v-model="parametersCustomers.sortDescending" :searchable="false" dir="rtl"
                                id="sortDescendingId" :options="sortDescendingData" :reduce="(value) => value.id"
                                label="name" class="bg-white" style="border-radius: 6px;" :clearable="false">
                                <template #no-options>
                                    موردی وجود ندارد
                                </template>
                            </v-select>
                        </b-form-group>
                    </b-col>
                    <b-col lg="6" md="4" class="mt-50 mt-md-2 mt-lg-25">
                        <b-button @click="removeFiltersCustomers" variant="secondary"
                            class="mt-md-25 mt-0 d-flex justify-content-center w-100" :disabled="loadingCustomers">
                            <span>حذف فیلتر ها</span>
                            <b-spinner v-if="loadingCustomers" variant="white" class="ml-50" small></b-spinner>
                        </b-button>
                    </b-col>
                    <b-col lg="6" md="4" class="mt-2 mt-md-2 mt-lg-25">
                        <b-button variant="info" @click="getCustomers" :disabled="loadingCustomers"
                            class="mt-md-25 mt-0 d-flex justify-content-center w-100">
                            <span>اعمال فیلتر</span>
                            <b-spinner v-if="loadingCustomers" variant="white" class="ml-50" small></b-spinner>
                        </b-button>
                    </b-col>
                    <b-col md="12" class="mt-2 mt-md-50 mt-lg-2">
                        <div class="d-flex align-items-center justify-content-between border border-info rounded px-1"
                            style="height: 41px;">
                            <div class="d-flex align-items-center">
                                <feather-icon size="18" icon="UsersIcon" class="mr-50" />
                                <h5 class="mb-0">مشتریان انتخاب شده</h5>
                            </div>
                            <div class="d-flex align-items-center">
                                <div class="d-flex align-items-center mb-0 mr-50">
                                    <h3 v-if="!loadingCustomers" class="font-weight-bolder mb-0">
                                        {{ selectedCount }}
                                    </h3>
                                    <b-spinner v-else small></b-spinner>
                                </div>
                                <span>مشتری</span>
                            </div>
                        </div>
                    </b-col>
                </b-row>
                <b-card class="p-0 mt-2" no-body>
                    <b-overlay :show="loadingCustomers" variant="transparent" opacity="1" blur="3px" rounded="sm">
                        <b-table v-if="customerList.length" responsive :items="customerList" :fields="fieldsCustomer"
                            class="mb-0" striped>
                            <template #head(select)>
                                <b-form-checkbox :indeterminate="isIndeterminate" v-model="isAllSelected"
                                    @change="toggleSelectAll"></b-form-checkbox>
                            </template>
                            <template #cell(select)="data">
                                <b-form-checkbox :checked="isRowChecked(data.item.id)"
                                    @change="toggleRow(data.item.id, $event)"></b-form-checkbox>
                            </template>
                            <template #cell(lastName)="data">
                                {{ data.item.lastName ? data.item.lastName : '-' }}
                            </template>
                            <template #cell(firstName)="data">
                                {{ data.item.firstName ? data.item.firstName : '-' }}
                            </template>
                        </b-table>
                        <div v-else class="text-center pt-5 pb-4">
                            موردی وجود ندارد
                        </div>
                    </b-overlay>
                </b-card>
                <b-pagination align="center" @input="getCustomers" v-model="parametersCustomers.pageIndex"
                    :total-rows="parametersCustomers.totalCount" :per-page="parametersCustomers.pageSize" />
                <b-button :disabled="!selectedCount" variant="info" @click="managementCustomerSelection(2)"
                    class="w-100 mt-2 mb-50">
                    تایید
                </b-button>
            </b-modal>
        </div>

        <b-card v-else>
            <div class="d-flex align-items-center justify-content-center flex-wrap text-danger text-center">
                <span>برای دسترسی به این قسمت، لطفا</span>
                <router-link class="mx-25" to="/identity-management">هویت</router-link>
                <span>خود را تایید کنید.</span>
            </div>
        </b-card>
    </div>
</template>


<script>
import { BCard, BCardText, BCardBody, BButton, BRow, BCol, BForm, BFormCheckbox, BFormRadio, BFormTextarea, BTable, BBadge, BPagination, BOverlay, BAvatar, BMediaAside, BMedia, BFormFile, BMediaBody, BFormInput, BFormGroup, BSpinner } from 'bootstrap-vue';
import { storeService } from '@core/services';
import { ValidationProvider, ValidationObserver } from 'vee-validate';
import { required } from '@validations';
import vSelect from 'vue-select';
import Cleave from 'vue-cleave-component'
import 'cleave.js/dist/addons/cleave-phone.ir'
import { accessHandling } from '@core/mixins/accessHandling';

export default {
    components: {
        Cleave,
        ValidationProvider,
        ValidationObserver,
        BCard,
        BCardText,
        BButton,
        BCardBody,
        BRow,
        BCol,
        BTable,
        BPagination,
        BOverlay,
        BAvatar,
        BMediaAside,
        BMedia,
        BSpinner,
        BBadge,
        BMediaBody,
        BFormInput,
        BFormGroup,
        BForm,
        BFormRadio,
        BFormTextarea,
        BFormFile,
        BFormCheckbox,
        vSelect
    },
    mixins: [accessHandling],
    data() {
        return {
            options: {
                number: {
                    numeral: true,
                    numeralThousandsGroupStyle: 'thousand',
                },
            },
            isAdminIdentityVerified: false,
            required,
            loadingButton: false,
            loadingPage: true,
            loading: false,
            loadingbuttons: [],
            currentDate: '',
            storeId: null,
            parameters: {
                pageIndex: 1,
                pageSize: 12,
                totalCount: null,
                from: null,
                to: null,
                isActive: null,
            },
            selectAll: false,
            isAllSelected: false,
            isIndeterminate: false,
            campaigns: [],
            listTypes: [
                {
                    name: 'مشتریان',
                    id: 1,
                },
                {
                    name: 'تولد',
                    id: 0,
                },
                {
                    name: 'عمومی',
                    id: 2,
                },
            ],
            fieldsProduct: [
                {
                    key: 'productInfo',
                    label: '',
                },
                {
                    key: 'price',
                    label: '',
                },
            ],
            fieldsCustomer: [
                {
                    key: 'select',
                    label: '',
                },
                {
                    key: 'firstName',
                    label: 'نام',
                },
                {
                    key: 'lastName',
                    label: 'نام خانوادگی',
                },
                {
                    key: 'phoneNumber',
                    label: 'شماره همراه',
                },
                {
                    key: 'number',
                    label: 'شماره اشتراک',
                },
            ],
            fields: [
                {
                    key: 'title',
                    label: 'عنوان',
                },
                {
                    key: 'type',
                    label: 'نوع',
                },
                {
                    key: 'discountPercent',
                    label: 'درصد تخفیف',
                },
                {
                    key: 'priority',
                    label: 'اولویت',
                },
                {
                    key: 'startDate',
                    label: 'زمان شروع',
                },
                {
                    key: 'endDate',
                    label: 'زمان پایان',
                },
                {
                    key: 'isActive',
                    label: 'وضعیت',
                },
                {
                    key: 'ordersCount',
                    label: 'تعداد فاکتور ثبت شده',
                },
                {
                    key: 'totalDiscountGiven',
                    label: 'جمع مبلغ تخفیف داده شده (ریال)',
                },
                {
                    key: 'totalOrdersAmount',
                    label: 'جمع مبلغ فاکتور ثبت شده (ریال)',
                },
                {
                    key: 'createdAt',
                    label: 'تاریخ ایجاد',
                },
                {
                    key: 'edit',
                    label: 'ویرایش',
                },
            ],
            customerList: [],
            excludeCustomerIds: [],
            loadingCustomers: false,
            parametersUsers: {
                pageIndex: 1,
                pageSize: 90,
            },
            isActiveManagement: [
                { name: 'نمایش همه', id: null },
                { name: 'فعال', id: true },
                { name: 'غیرفعال', id: false },
            ],
            categories: [],
            products: [],
            sortByData: [
                { name: 'تاریخ ایجاد', id: 0 },
                { name: 'امتیاز', id: 1 },
                { name: 'اعتبار', id: 2 },
                { name: 'زمان آخرین خرید', id: 3 },
                { name: 'تعداد خرید', id: 4 },
                { name: 'مبلغ خرید', id: 5 },
            ],
            groupIdData: [
                { name: 'همراهِ همیشگی', id: 1 },
                { name: 'همراهِ هفتگی', id: 2 },
                { name: 'همراهِ ماهانه', id: 3 },
                { name: 'لبه‌ی فراموشی', id: 4 },
                { name: 'مشتریان خاموش', id: 5 },
            ],
            sortDescendingData: [
                { name: 'صعودی', id: false },
                { name: 'نزولی', id: true }
            ],
            parametersCustomers: {
                pageIndex: 1,
                pageSize: 12,
                totalCount: null,
                phoneNumber: null,
                searchTerm: null,
                sortBy: null,
                levelNumber: null,
                sortDescending: null,
                maxScore: null,
                minScore: null,
                groupId: null,
                maxTotalOrdersCount: null,
                minTotalOrdersCount: null,
                maxTotalOrdersAmount: null,
                minTotalOrdersAmount: null,
                maxDaysNumberSinceLastOrdered: null,
                minDaysNumberSinceLastOrdered: null,
                favoriteProductId: null,
            },
            campaignStatus: true,
            staticCustomerIds: [],
            form: {
                title: null,
                description: null,
                type: 1,
                discountPercent: null,
                priority: null,
                minimumPurchaseAmount: null,
                maxOrdersCount: null,
                maxTotalDiscountAmount: null,
                startDate: null,
                endDate: null,
                productIds: [],
                customersFilters: null,
                excludeCustomerIds: [],
                staticCustomerIds: [],
            },
            campaignDescription: [
                // 'انتخاب محصولات اختیاری است. اگر یک یا چند محصول انتخاب شود، تخفیف فقط روی همان محصولات اعمال خواهد شد. اما اگر هیچ محصولی انتخاب نشود، تخفیف روی کل فاکتور اعمال می‌شود.',
                'در صورتی که برای مشتریان یک کمپین درخواست ارسال پیامک ثبت شود، می‌توانید وضعیت و روند پیگیری آن را در صفحهٔ «پیامک / ارسال گروهی» مشاهده کنید.',
                'حداکثر تعداد فاکتور در کمپین: مشخص می‌کند در این کمپین چه تعداد فاکتور قابل ثبت است. پس از رسیدن به این تعداد، کمپین به‌صورت خودکار غیرفعال می‌شود.',
                'حداقل مبلغ خرید در هر فاکتور: مشخص می‌کند برای اعمال تخفیف کمپین، مبلغ خرید مشتری باید حداقل به این مبلغ برسد.',
                'حداکثر مجموع تخفیف در کمپین: مشخص می‌کند با توجه به بودجه تعیین‌شده، کمپین تا چه میزان می‌تواند تخفیف ارائه دهد. پس از رسیدن به این سقف، کمپین به‌صورت خودکار غیرفعال می‌شود.',
            ],
            modeCampaign: '',
            idCampaign: null
        }
    },
    watch: {
        'form.type'() {
            if (this.form.type != 1) {
                this.selectAll = false
                this.isAllSelected = false
                this.isIndeterminate = false
                this.excludeCustomerIds = []
                this.staticCustomerIds = []
                this.form.excludeCustomerIds = []
                this.form.staticCustomerIds = []
            }
        },
    },
    computed: {
        selectedCount() {
            if (this.selectAll) {
                return this.parametersCustomers.totalCount - this.excludeCustomerIds.length;
            } else {
                return this.staticCustomerIds.length;
            }
        }
    },
    methods: {
        formatDate2(date) {
            return `${date.getFullYear()}-${String(date.getMonth() + 1).padStart(2, "0")}-${String(date.getDate()).padStart(2, "0")}`;
        },
        formatDate(dateString) {
            const [year, month, day] = dateString.split('-');
            return new Date(year, parseInt(month) - 1, day).toLocaleDateString('fa-IR');
        },
        showModalEdit(item, index) {
            if (this.accessHandling('employee', 'manage_campaigns')) {
                this.$set(this.loadingbuttons, index, true);
                this.idCampaign = item.id
                this.campaignStatus = item.isActive
                this.staticCustomerIds = [];
                this.excludeCustomerIds = [];
                this.selectAll = false;
                this.isAllSelected = false;
                this.isIndeterminate = false;
                this.products = []
                this.form.title = null
                this.form.description = null
                this.form.type = 1
                this.form.discountPercent = null
                this.form.priority = null
                this.form.minimumPurchaseAmount = null
                this.form.maxOrdersCount = null
                this.form.maxTotalDiscountAmount = null
                this.form.startDate = null
                this.form.endDate = null
                this.form.productIds = []
                this.form.customersFilters = null
                this.modeCampaign = 'ویرایش'
                storeService.getAllProducts(this.storeId).then(({ data }) => {
                    let categories = data.categories
                    this.categories = data.categories
                    if (categories.length) {
                        categories.forEach(obj => {
                            obj.products.forEach(product => {
                                this.products.push(product)
                            });
                        });
                    }
                    storeService.getCampaignsById(this.storeId, item.id).then(({ data }) => {
                        this.form.title = data.title
                        this.form.description = data.description
                        this.form.type = data.type
                        this.form.discountPercent = data.discountPercent
                        this.form.priority = data.priority
                        this.form.minimumPurchaseAmount = data.minimumPurchaseAmount
                        this.form.maxOrdersCount = data.maxOrdersCount
                        this.form.maxTotalDiscountAmount = data.maxTotalDiscountAmount
                        this.form.startDate = data.startDate
                        this.form.endDate = data.endDate
                        this.form.productIds = data.productIds
                        this.form.customersFilters = data.customersFilters
                        if (data.customersFilters) {
                            this.parametersCustomers.sortBy = null
                            this.parametersCustomers.sortDescending = null
                            this.parametersCustomers.phoneNumber = data.customersFilters.phoneNumber
                            this.parametersCustomers.searchTerm = data.customersFilters.searchTerm
                            this.parametersCustomers.levelNumber = data.customersFilters.levelNumber
                            this.parametersCustomers.favoriteProductId = data.customersFilters.favoriteProductId
                            this.parametersCustomers.groupId = data.customersFilters.groupId
                            data.customersFilters.scoreRange ? this.parametersCustomers.maxScore = data.customersFilters.scoreRange.to : null
                            data.customersFilters.scoreRange ? this.parametersCustomers.minScore = data.customersFilters.scoreRange.from : null
                            data.customersFilters.totalOrdersAmountRange ? this.parametersCustomers.maxTotalOrdersAmount = data.customersFilters.totalOrdersAmountRange.to : null
                            data.customersFilters.totalOrdersAmountRange ? this.parametersCustomers.minTotalOrdersAmount = data.customersFilters.totalOrdersAmountRange.from : null
                            data.customersFilters.totalOrdersCountRange ? this.parametersCustomers.maxTotalOrdersCount = data.customersFilters.totalOrdersCountRange.to : null
                            data.customersFilters.totalOrdersCountRange ? this.parametersCustomers.minTotalOrdersCount = data.customersFilters.totalOrdersCountRange.from : null
                            data.customersFilters.daysNumberSinceLastOrderedRange ? this.parametersCustomers.maxDaysNumberSinceLastOrdered = data.customersFilters.daysNumberSinceLastOrderedRange.to : null
                            data.customersFilters.daysNumberSinceLastOrderedRange ? this.parametersCustomers.minDaysNumberSinceLastOrdered = data.customersFilters.daysNumberSinceLastOrderedRange.from : null
                        }
                        this.form.excludeCustomerIds = data.excludeCustomerIds
                        this.form.staticCustomerIds = data.staticCustomerIds
                        this.excludeCustomerIds = data.excludeCustomerIds
                        this.staticCustomerIds = data.staticCustomerIds
                        if (data.customersFilters) {
                            this.selectAll = true
                            this.isAllSelected = true
                        }
                        else {
                            this.selectAll = false
                            this.isAllSelected = false
                        }
                        storeService.getCustomers(this.storeId, this.parametersCustomers).then(({ data }) => {
                            if (this.selectAll && this.parametersCustomers.totalCount !== null && this.parametersCustomers.totalCount !== data.totalCount) {
                                this.excludeCustomerIds = [];
                                this.staticCustomerIds = [];
                                this.selectAll = false;
                                this.isAllSelected = false;
                                this.isIndeterminate = false;
                            }
                            this.parametersCustomers.totalCount = data.totalCount
                            this.customerList = data.items
                            this.$bvModal.show('create-campaign')
                        })
                            .finally(() => {
                                this.$set(this.loadingbuttons, index, false);
                            });
                    })
                })
            }
            else {
                this.$notif({ type: 'error', title: 'شما به این بخش دسترسی ندارید' });
            }
        },
        getTableItems() {
            const items = [];
            this.categories.forEach(category => {
                const activeProducts = category.products.filter(p => p.isActive === true);
                if (activeProducts.length === 0) return;
                items.push({
                    id: `category-${category.id}`,
                    isCategory: true,
                    productName: category.name_Fa,
                    categoryId: category.id,
                    basePrice: null,
                });
                activeProducts.forEach(product => {
                    items.push({
                        id: product.id,
                        isCategory: false,
                        productName: product.name_Fa,
                        categoryId: category.id,
                        basePrice: product.basePrice,
                    });
                });
            });

            return items;
        },
        isCategoryFullySelected(categoryId) {
            const category = this.categories.find(c => c.id === categoryId);
            if (!category) return false;
            const activeProducts = category.products.filter(p => p.isActive === true);
            return activeProducts.length > 0 && activeProducts.every(p =>
                this.form.productIds.includes(p.id)
            );
        },
        isCategoryPartiallySelected(categoryId) {
            const category = this.categories.find(c => c.id === categoryId);
            if (!category) return false;
            const activeProducts = category.products.filter(p => p.isActive === true);
            const selectedCount = activeProducts.filter(p =>
                this.form.productIds.includes(p.id)
            ).length;
            return selectedCount > 0 && selectedCount < activeProducts.length;
        },
        toggleCategorySelection(categoryId) {
            const category = this.categories.find(c => c.id === categoryId);
            if (!category) return;
            const activeProducts = category.products.filter(p => p.isActive === true);
            const categoryProductIds = activeProducts.map(p => p.id);
            const allSelected = categoryProductIds.every(id =>
                this.form.productIds.includes(id)
            );
            if (allSelected) {
                this.form.productIds = this.form.productIds.filter(
                    id => !categoryProductIds.includes(id)
                );
            } else {
                categoryProductIds.forEach(id => {
                    if (!this.form.productIds.includes(id)) {
                        this.form.productIds.push(id);
                    }
                });
            }
        },
        createOrEdit() {
            if (this.modeCampaign == 'ایجاد') {
                this.createCampaign()
            }
            else {
                this.editCampaignsById()
            }
        },
        editCampaignsById() {
            this.$refs.createCampaign.validate().then((success) => {
                if (success) {
                    if (!this.selectedCount && this.form.type == 1) {
                        this.$bvModal.hide('create-campaign')
                        this.$bvModal.show('customer-choice')
                    }
                    else {
                        this.loadingButton = true
                        if (this.form.type == 1) {
                            if (this.selectAll) {
                                this.form.customersFilters = {}
                                this.parametersCustomers.phoneNumber ? this.form.customersFilters.phoneNumber = this.parametersCustomers.phoneNumber : null
                                this.parametersCustomers.searchTerm ? this.form.customersFilters.searchTerm = this.parametersCustomers.searchTerm : null
                                this.parametersCustomers.favoriteProductId ? this.form.customersFilters.favoriteProductId = this.parametersCustomers.favoriteProductId : null
                                this.parametersCustomers.levelNumber ? this.form.customersFilters.levelNumber = this.parametersCustomers.levelNumber : null
                                this.parametersCustomers.groupId ? this.form.customersFilters.groupId = this.parametersCustomers.groupId : null
                                if (this.parametersCustomers.maxScore || this.parametersCustomers.minScore || this.parametersCustomers.minScore == 0) {
                                    this.form.customersFilters.scoreRange = {}
                                    this.parametersCustomers.minScore ? this.form.customersFilters.scoreRange.from = this.parametersCustomers.minScore : null
                                    this.parametersCustomers.maxScore ? this.form.customersFilters.scoreRange.to = this.parametersCustomers.maxScore : null
                                }
                                if (this.parametersCustomers.maxDaysNumberSinceLastOrdered || this.parametersCustomers.minDaysNumberSinceLastOrdered || this.parametersCustomers.minDaysNumberSinceLastOrdered == 0) {
                                    this.form.customersFilters.daysNumberSinceLastOrderedRange = {}
                                    this.parametersCustomers.minDaysNumberSinceLastOrdered ? this.form.customersFilters.daysNumberSinceLastOrderedRange.from = this.parametersCustomers.minDaysNumberSinceLastOrdered : null
                                    this.parametersCustomers.maxDaysNumberSinceLastOrdered ? this.form.customersFilters.daysNumberSinceLastOrderedRange.to = this.parametersCustomers.maxDaysNumberSinceLastOrdered : null
                                }
                                if (this.parametersCustomers.maxTotalOrdersCount || this.parametersCustomers.minTotalOrdersCount || this.parametersCustomers.minTotalOrdersCount == 0) {
                                    this.form.customersFilters.totalOrdersCountRange = {}
                                    this.parametersCustomers.minTotalOrdersCount ? this.form.customersFilters.totalOrdersCountRange.from = this.parametersCustomers.minTotalOrdersCount : null
                                    this.parametersCustomers.maxTotalOrdersCount ? this.form.customersFilters.totalOrdersCountRange.to = this.parametersCustomers.maxTotalOrdersCount : null
                                }
                                if (this.parametersCustomers.maxTotalOrdersAmount || this.parametersCustomers.minTotalOrdersAmount || this.parametersCustomers.minTotalOrdersAmount == 0) {
                                    this.form.customersFilters.totalOrdersAmountRange = {}
                                    this.parametersCustomers.minTotalOrdersAmount ? this.form.customersFilters.totalOrdersAmountRange.from = this.parametersCustomers.minTotalOrdersAmount : null
                                    this.parametersCustomers.maxTotalOrdersAmount ? this.form.customersFilters.totalOrdersAmountRange.to = this.parametersCustomers.maxTotalOrdersAmount : null
                                }
                                this.form.excludeCustomerIds = this.excludeCustomerIds
                                this.form.staticCustomerIds = []
                            }
                            else {
                                this.form.customersFilters = null
                                this.form.staticCustomerIds = this.staticCustomerIds
                                this.form.excludeCustomerIds = []
                            }
                        }
                        else {
                            this.form.customersFilters = null
                            this.form.excludeCustomerIds = []
                            this.form.staticCustomerIds = []
                        }
                        this.form.maxTotalDiscountAmount ? null : this.form.maxTotalDiscountAmount = null
                        this.form.minimumPurchaseAmount ? null : this.form.minimumPurchaseAmount = null
                        this.form.maxOrdersCount ? null : this.form.maxOrdersCount = null
                        storeService.editCampaignsById(this.storeId, this.idCampaign, this.form).then(({ data }) => {
                            this.$refs.createCampaign.reset();
                            this.$notif({ type: 'success' });
                            this.$bvModal.hide('create-campaign')
                            this.getCampaigns()
                        })
                            .finally(() => {
                                this.loadingButton = false
                            });
                    }
                }
            });
        },
        toggleProductSelection(productId) {
            if (this.form.productIds.includes(productId)) {
                this.form.productIds = this.form.productIds.filter(id => id !== productId);
            } else {
                this.form.productIds.push(productId);
            }
        },
        managementCustomerSelection(type) {
            if (type == 1) {
                this.$bvModal.hide('create-campaign')
                this.$bvModal.show('customer-choice')
            }
            else {
                this.$bvModal.hide('customer-choice')
                this.$bvModal.show('create-campaign')
            }
        },
        managementProductSelection(type) {
            if (type == 1) {
                this.$bvModal.hide('create-campaign')
                this.$bvModal.show('product-choice')
            }
            else {
                this.$bvModal.hide('product-choice')
                this.$bvModal.show('create-campaign')
            }
        },
        removeFilters() {
            this.parameters.isActive = null;
            this.parameters.from = null;
            this.parameters.to = null;
            this.getCampaigns()
        },
        removeFiltersCustomers() {
            this.parametersCustomers.phoneNumber = null;
            this.parametersCustomers.searchTerm = null;
            this.parametersCustomers.sortBy = null;
            this.parametersCustomers.levelNumber = null;
            this.parametersCustomers.sortDescending = null;
            this.parametersCustomers.maxScore = null;
            this.parametersCustomers.minScore = null;
            this.parametersCustomers.groupId = null;
            this.parametersCustomers.maxTotalOrdersCount = null;
            this.parametersCustomers.minTotalOrdersCount = null;
            this.parametersCustomers.maxTotalOrdersAmount = null;
            this.parametersCustomers.minTotalOrdersAmount = null;
            this.parametersCustomers.maxDaysNumberSinceLastOrdered = null;
            this.parametersCustomers.minDaysNumberSinceLastOrdered = null;
            this.parametersCustomers.favoriteProductId = null;
            this.getCustomers()
        },
        customerChoice() {
            if (this.accessHandling('employee', 'manage_campaigns')) {
                this.loadingButton = true
                this.staticCustomerIds = [];
                this.excludeCustomerIds = [];
                this.selectAll = false;
                this.isAllSelected = false;
                this.isIndeterminate = false;
                this.products = []
                this.form.title = null
                this.form.description = null
                this.form.type = 1
                this.form.discountPercent = null
                this.form.priority = null
                this.form.minimumPurchaseAmount = null
                this.form.maxOrdersCount = null
                this.form.maxTotalDiscountAmount = null
                this.form.startDate = null
                this.form.endDate = null
                this.form.productIds = []
                this.form.customersFilters = null
                this.getAllProducts()
                this.removeFiltersCustomers()
            }
            else {
                this.$notif({ type: 'error', title: 'شما به این بخش دسترسی ندارید' });
            }
        },
        getDisplayDateTime(dateValue) {
            if (!dateValue) return null;
            if (typeof dateValue === 'string') {
                const date = new Date(dateValue);
                if (isNaN(date.getTime())) return null;
                const datePart = date.toLocaleDateString('fa-IR');
                const timePart = date.toLocaleTimeString('fa-IR', {
                    hour: '2-digit',
                    minute: '2-digit',
                    hour12: false
                });
                return `${datePart} - ${timePart}`;
            }
            if (dateValue instanceof Date) {
                const datePart = dateValue.toLocaleDateString('fa-IR');
                const timePart = dateValue.toLocaleTimeString('fa-IR', {
                    hour: '2-digit',
                    minute: '2-digit',
                    hour12: false
                });
                return `${datePart} - ${timePart}`;
            }
            return null;
        },
        isRowChecked(id) {
            if (this.selectAll) {
                return !this.excludeCustomerIds.includes(id);
            } else {
                return this.staticCustomerIds.includes(id);
            }
        },
        toggleRow(id, checked) {
            if (this.selectAll) {
                if (!checked) {
                    if (!this.excludeCustomerIds.includes(id)) {
                        this.excludeCustomerIds.push(id);
                    }
                } else {
                    this.excludeCustomerIds = this.excludeCustomerIds.filter(x => x !== id);
                }
            } else {
                if (checked) {
                    if (!this.staticCustomerIds.includes(id)) {
                        this.staticCustomerIds.push(id);
                    }
                } else {
                    this.staticCustomerIds = this.staticCustomerIds.filter(x => x !== id);
                }
            }
            this.updateHeaderCheckbox();
        },
        toggleSelectAll(checked) {
            this.selectAll = checked;
            this.isIndeterminate = false;
            if (checked) {
                this.staticCustomerIds = [];
                this.excludeCustomerIds = [];
            } else {
                this.staticCustomerIds = [];
                this.excludeCustomerIds = [];
            }
        },
        updateHeaderCheckbox() {
            const pageIds = this.customerList.map(c => c.id);
            let selectedCount = 0;
            if (this.selectAll) {
                selectedCount = pageIds.filter(id => !this.excludeCustomerIds.includes(id)).length;
            } else {
                selectedCount = pageIds.filter(id => this.staticCustomerIds.includes(id)).length;
            }
            if (selectedCount === pageIds.length) {
                this.isAllSelected = true;
                this.isIndeterminate = false;
            } else if (selectedCount > 0) {
                this.isAllSelected = false;
                this.isIndeterminate = true;
            } else {
                this.isAllSelected = false;
                this.isIndeterminate = false;
            }
        },
        getAllProducts() {
            storeService.getAllProducts(this.storeId).then(({ data }) => {
                let categories = data.categories
                this.categories = data.categories
                if (categories.length) {
                    categories.forEach(obj => {
                        obj.products.forEach(product => {
                            this.products.push(product)
                        });
                    });
                }
            })
        },
        campaignChangeStatus() {
            this.loadingButton = true
            storeService.campaignChangeStatus(this.storeId, this.idCampaign, { isActive: !this.campaignStatus }).then(({ data }) => {
                this.$notif({ type: 'success' });
                this.$bvModal.hide('create-campaign')
                this.getCampaigns()
            })
                .finally(() => {
                    this.loadingButton = false
                });
        },
        getCustomers() {
            this.loadingCustomers = true
            storeService.getCustomers(this.storeId, this.parametersCustomers).then(({ data }) => {
                if (this.selectAll && this.parametersCustomers.totalCount !== null && this.parametersCustomers.totalCount !== data.totalCount) {
                    this.excludeCustomerIds = [];
                    this.staticCustomerIds = [];
                    this.selectAll = false;
                    this.isAllSelected = false;
                    this.isIndeterminate = false;
                }
                this.parametersCustomers.totalCount = data.totalCount
                this.customerList = data.items
                this.loadingCustomers = false
                if (this.loadingButton) {
                    this.modeCampaign = 'ایجاد'
                    this.$bvModal.show('create-campaign')
                }
                this.loadingButton = false
            })
        },
        getCampaigns() {
            this.loading = true;
            this.loadingbuttons = []
            storeService.getCampaigns(this.storeId, this.parameters).then(({ data }) => {
                if (this.loadingPage) {
                    this.parameters.totalCount = data.totalCount
                    this.campaigns = data.items
                    if (this.campaigns.length) {
                        this.campaigns.forEach(obj => {
                            this.loadingbuttons.push(false)
                        });
                    }
                    this.loading = false;
                }
                else {
                    setTimeout(() => {
                        this.parameters.totalCount = data.totalCount
                        this.campaigns = data.items
                        if (this.campaigns.length) {
                            this.campaigns.forEach(obj => {
                                this.loadingbuttons.push(false)
                            });
                        }
                        this.loading = false;
                    }, 369)
                }
                this.loadingPage = false;
            })
        },
        createCampaign() {
            this.$refs.createCampaign.validate().then((success) => {
                if (success) {
                    if (!this.selectedCount && this.form.type == 1) {
                        this.$bvModal.hide('create-campaign')
                        this.$bvModal.show('customer-choice')
                    }
                    else {
                        this.loadingButton = true
                        if (this.form.type == 1) {
                            if (this.selectAll) {
                                this.form.customersFilters = {}
                                this.parametersCustomers.phoneNumber ? this.form.customersFilters.phoneNumber = this.parametersCustomers.phoneNumber : null
                                this.parametersCustomers.searchTerm ? this.form.customersFilters.searchTerm = this.parametersCustomers.searchTerm : null
                                this.parametersCustomers.favoriteProductId ? this.form.customersFilters.favoriteProductId = this.parametersCustomers.favoriteProductId : null
                                this.parametersCustomers.levelNumber ? this.form.customersFilters.levelNumber = this.parametersCustomers.levelNumber : null
                                this.parametersCustomers.groupId ? this.form.customersFilters.groupId = this.parametersCustomers.groupId : null
                                if (this.parametersCustomers.maxScore || this.parametersCustomers.minScore || this.parametersCustomers.minScore == 0) {
                                    this.form.customersFilters.scoreRange = {}
                                    this.parametersCustomers.minScore ? this.form.customersFilters.scoreRange.from = this.parametersCustomers.minScore : null
                                    this.parametersCustomers.maxScore ? this.form.customersFilters.scoreRange.to = this.parametersCustomers.maxScore : null
                                }
                                if (this.parametersCustomers.maxDaysNumberSinceLastOrdered || this.parametersCustomers.minDaysNumberSinceLastOrdered || this.parametersCustomers.minDaysNumberSinceLastOrdered == 0) {
                                    this.form.customersFilters.daysNumberSinceLastOrderedRange = {}
                                    this.parametersCustomers.minDaysNumberSinceLastOrdered ? this.form.customersFilters.daysNumberSinceLastOrderedRange.from = this.parametersCustomers.minDaysNumberSinceLastOrdered : null
                                    this.parametersCustomers.maxDaysNumberSinceLastOrdered ? this.form.customersFilters.daysNumberSinceLastOrderedRange.to = this.parametersCustomers.maxDaysNumberSinceLastOrdered : null
                                }
                                if (this.parametersCustomers.maxTotalOrdersCount || this.parametersCustomers.minTotalOrdersCount || this.parametersCustomers.minTotalOrdersCount == 0) {
                                    this.form.customersFilters.totalOrdersCountRange = {}
                                    this.parametersCustomers.minTotalOrdersCount ? this.form.customersFilters.totalOrdersCountRange.from = this.parametersCustomers.minTotalOrdersCount : null
                                    this.parametersCustomers.maxTotalOrdersCount ? this.form.customersFilters.totalOrdersCountRange.to = this.parametersCustomers.maxTotalOrdersCount : null
                                }
                                if (this.parametersCustomers.maxTotalOrdersAmount || this.parametersCustomers.minTotalOrdersAmount || this.parametersCustomers.minTotalOrdersAmount == 0) {
                                    this.form.customersFilters.totalOrdersAmountRange = {}
                                    this.parametersCustomers.minTotalOrdersAmount ? this.form.customersFilters.totalOrdersAmountRange.from = this.parametersCustomers.minTotalOrdersAmount : null
                                    this.parametersCustomers.maxTotalOrdersAmount ? this.form.customersFilters.totalOrdersAmountRange.to = this.parametersCustomers.maxTotalOrdersAmount : null
                                }
                                this.form.excludeCustomerIds = this.excludeCustomerIds
                                this.form.staticCustomerIds = []
                            }
                            else {
                                this.form.customersFilters = null
                                this.form.staticCustomerIds = this.staticCustomerIds
                                this.form.excludeCustomerIds = []
                            }
                        }
                        else {
                            this.form.customersFilters = null
                            this.form.excludeCustomerIds = []
                            this.form.staticCustomerIds = []
                        }
                        this.form.maxTotalDiscountAmount ? null : this.form.maxTotalDiscountAmount = null
                        this.form.minimumPurchaseAmount ? null : this.form.minimumPurchaseAmount = null
                        this.form.maxOrdersCount ? null : this.form.maxOrdersCount = null
                        storeService.createCampaign(this.storeId, this.form).then(({ data }) => {
                            this.$refs.createCampaign.reset();
                            this.$notif({ type: 'success' });
                            this.$bvModal.hide('create-campaign')
                            this.getCampaigns()
                        })
                            .finally(() => {
                                this.loadingButton = false
                            });
                    }
                }
            });
        },
        getCompletionStatus() {
            this.loadingPage = true;
            storeService.getCompletionStatus(this.storeId).then(({ data }) => {
                this.isAdminIdentityVerified = data.isAdminIdentityVerified;
                if (this.isAdminIdentityVerified) {
                    this.getCampaigns()
                }
                else {
                    this.loadingPage = false;
                }
            })
        },
    },
    mounted() {
        this.storeId = localStorage.getItem("storeId")
        const tomorrow = new Date();
        const today = new Date();
        tomorrow.setDate(today.getDate());
        this.currentDate = this.formatDate2(tomorrow);
        this.getCompletionStatus()
    },
};
</script>

<style lang="scss">
@import '@core/scss/vue/libs/vue-select.scss';
</style>